import { render } from "./BaseHeader.vue?vue&type=template&id=5ad70f6a&scoped=true&ts=true"
import script from "./BaseHeader.vue?vue&type=script&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=5ad70f6a&lang=scss&scoped=true"
import "./BaseHeader.vue?vue&type=style&index=1&id=5ad70f6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad70f6a"]])

export default __exports__